import { useEffect, useState } from 'react';

import fetch from 'unfetch';
import { handleError } from '../../components/utils/ErrorHandling';
import { BASE_URL } from '../../globals';
/**
 *
 * @param {*} phoneNumber The phone number to verify
 * @param {*} password The password of the user
 * @returns Sends an sms to the user. Returns either status:success or status:error.
 */
const signupSMS = async (phoneNumber, password) => {
	const url = `${BASE_URL}/api/signup/smsconfirmation`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
		},
		body: JSON.stringify({ phoneNumber: phoneNumber, password: password }),
	}).catch(handleError);

	if (res.ok) {
		return { status: 'success' };
	} else {
		localStorage.clear();
		return { status: 'error' };
	}
};
export default signupSMS;
